export default __webpack_public_path__ + "static/media/6.858a7a6b.png";